import { apiClient, type DcUserExEntity } from '@/libs/api'

export type FetchDcUserQuery = {
  tenantKey: string
  userId: number
}

export const fetchDcUser = async (
  { tenantKey, userId }: FetchDcUserQuery,
  signal?: AbortSignal
): Promise<DcUserExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .dc_users._id(userId)
    .$get({ config: { signal } })
  return data
}
